import { render } from "./FpuiInputRadio.vue?vue&type=template&id=f40bf468&lang=pug"
import script from "./FpuiInputRadio.vue?vue&type=script&lang=js"
export * from "./FpuiInputRadio.vue?vue&type=script&lang=js"

import "./FpuiInputRadio.vue?vue&type=style&index=0&id=f40bf468&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__